// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg width="14" height="19" viewBox="0 0 14 19" xmlns="http://www.w3.org/2000/svg">
        <title>IconMapPin</title>
        <g transform="translate(1)">
            <path fill="none" d="M5.441 17.082c.309.46.812.46 1.118 0 0 0 5.162-7.45 5.162-10.61a5.721 5.721 0 0 0-11.442 0c0 3.16 5.162 10.61 5.162 10.61z" stroke-width="1.5"/>
            <circle stroke="none" cx="6" cy="6.75" r="1.5"/>
        </g>
    </svg>
`
};

export const IconMapPin = () => <span dangerouslySetInnerHTML={icon} />;

export default IconMapPin;
